exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".el-dialog.inventory-dialog{width:920px!important;max-width:calc(100vw - 48px)!important;box-sizing:border-box}.el-dialog.inventory-dialog .el-dialog__header{padding:24px 28px 14px!important}.el-dialog.inventory-dialog .el-dialog__body{padding:4px 28px 10px!important}.el-dialog.inventory-dialog .el-dialog__footer{padding:14px 28px 20px!important;text-align:right!important}.inventory-dialog__title{font-size:16px;font-weight:700;color:#000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-16800532!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/components/yunying/onlineMatch/InventoryDialog.vue
// module id = 452
// module chunks = 0